export const initFacebookPixel = (pixelId) => {
    if (!pixelId) return;

    try {
        window.parent?.postMessage({
            type: 'streamchat:init-fbpixel',
            payload: { pixelId }
        }, '*');
    } catch {}
};
